import GetAppraisalOperationsFromXLSFile
  from '@/application/services/readers/get-appraisal-operations-xls-file';
import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getAppraisalOperations = file => {
  const reader = new GetAppraisalOperationsFromXLSFile();
  return reader.process(file);
};

export const createAppraisal = async appraisal => {
  const response = await requestFunnel.post('appraisals', appraisal, getOptions());
  return response.data;
};

export const getAppraisals = async () => {
  const response = await requestFunnel.get('appraisals/', getOptions());
  return response.data;
};

export const getAppraisalsByTradingStatus = async tradingStatus => {
  const response = await requestFunnel.get(`appraisals/by-status/${tradingStatus}`, getOptions());
  return response.data;
};

export const amend = async body => {
  const response = await requestFunnel.post('appraisals/amend', body, getOptions());
  return response.data;
};
